import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import mainImage from "../Images/article_Banner.jpg";
import Card from "./Card";
import CardsSection from "./ProductscardsSection";
import bannerImage from "../Images/Gravel-Bike mit CP CycleParts.png";
import subImage1 from "../Images/_MG_9655.jpg";
import subImage2 from "../Images/_MG_9708.jpg";
import ReactImageMagnify from "react-image-magnify";
import Pagination from "./Pagination";
import { useNavigate, useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Dailog from "./Dailog";
import { useTranslation } from "react-i18next";
const Articles = () => {
  const [selectedItem, setSelectedItem] = useState("");
  const { productname } = useParams();
  const [category, setCategory] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [articles, setArticles] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const closeRef = useRef(null);
  const [selectedColor, setSelectedColor] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);
  const itemSection = useRef(null);
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const navigate = useNavigate();
  const location = useLocation();
  const selectedPage = (number) => {
    setCurrentPage(number);
    // itemSection.current?.scrollIntoView({
    //   behavior:"smooth"
    // })
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blocks]);

  const products = async () => {
    try {
      const response = await axios.get(
        "https://data.bbf-bike.de/catalog/list/categories/37",
      );
      setCategory(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    products();
  }, []);
  const germanDes = category
    ?.filter((item) => item?.bbf_cat_name === productname.replaceAll("-", " "))
    .map((item) => item?.translations?.german?.DESCRIPTION)
    .find((item) => item);

  const EnglishDes = category
    ?.filter((item) => item?.bbf_cat_name === productname.replaceAll("-", " "))
    .map((item) => item?.translations?.english?.DESCRIPTION)
    .find((item) => item);

  const publicId = category
    ?.filter((item) => item?.bbf_cat_name === productname.replaceAll("-", " "))
    ?.map((item) => item.bbf_cat_ID_PUBLICGRPORDER)
    .find((item) => item);
  const parentId = category
    ?.filter((item) => item?.bbf_cat_name === productname.replaceAll("-", " "))
    ?.map((item) => item.bbf_cat_parent_category)
    .find((item) => item);

  const nameOfTheSubCategory = category
    ?.filter((item) => item?.bbf_cat_ID_PUBLICGRPORDER === parentId)
    ?.map((item) => item.bbf_cat_name)
    .find((item) => item);

  const ArticlesList = async () => {
    try {
      const response = await axios.get(
        `https://data.bbf-bike.de/catalog/list/categories/articles/${publicId}`,
      );
      setArticles(response.data.articles);
      setBlocks(response.data.blocks);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    ArticlesList();
  }, [publicId]);
  const { partid } = useParams();

  const handleCardClick = (blockData) => {
    setSelectedBlock(blockData);

    navigate(`/products/articles/${productname}/${blockData?.PARTNO}`);
  };

  const closeHandler = () => {
    setSelectedBlock(null);
    navigate(`/products/articles/${productname}`);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = articles.slice(indexOfFirstItem, indexOfLastItem);
  // const findColor=(value)=>{
  // for(const x of articles)
  // }
  // const color= findColor("Farbe primär")

  const scrollPosition = useRef();

  return (
    <div className="bg-cp-black">
      <div className="min-h-[calc(100vh-140px)] h-auto">
        <div className="md:mt-[100px] overflow-hidden max-w-[1920px] m-auto">
          <div className=" bg-cp-black flex flex-col justify-center items-center relative">
            <h2 className="absolute md:w-[550px] xs:w-[250px] md:text-[32px] xs:text-[20px]  xs:mt-4 md:mt-0   font-Manrope-ExtraLight  text-cp-white xl:right-[45%]   xl:top-[20%] ">
              <b>{productname.toUpperCase().replaceAll("-", " ")}</b>
            </h2>

            <img
              src={mainImage}
              className="h-full xs:object-contain md:object-cover
          w-full md:px-20 lg:px-24 xs:px-6 "
            />
          </div>
          <div
            className="xs:h-[5px] lg:h-[10px] bg-cp-white"
            ref={scrollPosition}></div>
          <div
            className="bg-cp-black md:mb-[10px] xs:mb-[5px]"
            ref={itemSection}>
            <div className=" justify-start items-center pt-10 md:ml-20 lg:ml-40 xs:hidden md:flex ">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFiElEQVR4nO1ba2hcRRS+PuurYqU+kSJaaK2kyZ1zk8b4iIq29Z9YYv9UY5I7Z7PFSOsTnxGEUoUi0bI75yYSUxWx1DcIRcUHiP5Q1Aii9IfgE5uiVk19UBuZu3N3J5u72d1kbmYT9oP9kcx8d87MnPvNmTlzHaeOOuqoYwGgN7P6TCToRAH3oHC7Nu9sPjvRBpHgJCRgSLDUsQxO7E5O7BASTOR/gv3Fid3rTDhHGW8QhbuREzuYawiOcILHE2moElsI7pjU8eKfYPeZbvBCObrFDXHyup05RtdTTWcgwXiuffYtEqzdtGv1yX7AruYE30SegATnGGsUBfQWRhd6UbDv1N8vm3i+H7DLUcDrshPlbXE3FWxx108qI7gqKktloceEbVMbJXiOE/yhRnpXrobjdA+556KA25FgmVMl5ECq571Rtq5gd0W2pDMNS/SyrTtaT9TsfNAxhXSmYQkK+GGy+8N/KNwrNMOeV275SrXPR4LLOMFrcgarmQxO3nWlPMD464kEK5FgbyiEAj5HgusnG8ZQecZtRhueasfSSAPkq+gHbN3mnatO4eRdk5gG1BrUq1ZyFQiXQnPqD9tC9xRsj2y4Z7D19FrgqqVwvKjjh2RQZGR5TmWhBwX8EzPCP6JwL6kFrlwSU1m4OYwECTp7BtecNeuOS6SycGUocpHYEXyCAvZpxoz5Qct5Tg1xjYITvKfE5PdUFlqi//sB4zIKVGV7aolrDJ3D7ScUZoFtjzHyGW1G1tYCN4llZkJFfX3F5XLHVdgTsK/7BpYvss01DiQYUzPxTmy5YFtKLTm2uEbBiW3XIqoNxeX9/e3HIsGomq0/9fDXFtco0rnQd3+045KRVlz4GidMtrjGgQS+9k5ui60j4Nm4uNwW1yj6+52jUcCHyhAZmKwsriMDDyT4TdXZFwmTLa5xoDz+Euywcrc34+pwgq1xwmSLaxycWLacMHGCz1Sd8VS28XzbXKNI1wXRqUiYSkVqtrhSFzixESQYlN4yKy/ol8JE8FEkTL0Zb0VxHXkAERep2eL6AWvVBqZhVgMg4Q8yyAsTwV6nikjNBjenEWyHDK7kQDomwOuC2FCPEFETJk7wcLlITR5y2OYaRTrjXRDF4pzgxXhD3K64ra0trlGgYK+qBo7oeYEIuSNq+F4Z+nPncONptrnG4AdsnTbCw3F1OMFjUR0/YLfY5hpD38DyRXKdVUvNwbjEQ8+gexES/KvW5A+i42lb3IrQPdS2mBP7ghP7qjjXpkPm2sq9XyjgbWXEYT9obrLNrQi9GW9FwXXiyXKjkb+MINinHbs7jplqhLuxYCh70ja3KqBwb/ADdmOpcpnwjAQolYVLqxEgW1xj8OvCxxae8FUKTuyhmQqQLa4xIMEydfQsDRmN21PrAsSJPWGbaxR8ngofJ6+ZE9wqr8vMuPMo3PXaYcLT1URetriFcvaTejW2zGIA2LtqFn6Ny7lPJ0C2uNoAjHBiBzh5bTPqfF94lpbL0qJgj8bV4QRvxQmQLa5RYJks7XSRly2ucaDK0qKA9/XzNHlPp1zkZYtrFFzL0srLi/JKHCfvJrlp0kSqs5a4xm+F80LWJe4a2kitcY2jb6DlVBQQTLokLWA/J7i73DHzXHKlGMq7RZzgb7kEcmKPdOxedbxjCt1DbYtlstIPmi9GguNqiZvKNjXKjk/xFgEvOXMFTt6G6bbSSSLaD6hByOTT6rlT4WuTN4DC+8OqwaZGZ46h3VoX+URuXi/g/sQN6M656SgK+DLxpSkG6oMJ6fIfhx9S6LECQdqZT0DhemEcIOCFyjnwQInV4oD8oMqZT+AEKeW6v1TKkeIYfaeg/cYSvUiZFMJTIII0EqyplsvJaw+/JBEM5auQjIV11FGHs0DwPxjwX3NERufNAAAAAElFTkSuQmCC"
                className="h-7 w-7"
              />
              <Link to="/products">
                <h2 className="font-Manrope-ExtraLight text-[14px] py-1  border border-cp-green px-2 text-cp-white">
                  {t("products").charAt(0) +
                    t("products").slice(1).toLowerCase()}
                </h2>
              </Link>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFiElEQVR4nO1ba2hcRRS+PuurYqU+kSJaaK2kyZ1zk8b4iIq29Z9YYv9UY5I7Z7PFSOsTnxGEUoUi0bI75yYSUxWx1DcIRcUHiP5Q1Aii9IfgE5uiVk19UBuZu3N3J5u72d1kbmYT9oP9kcx8d87MnPvNmTlzHaeOOuqoYwGgN7P6TCToRAH3oHC7Nu9sPjvRBpHgJCRgSLDUsQxO7E5O7BASTOR/gv3Fid3rTDhHGW8QhbuREzuYawiOcILHE2moElsI7pjU8eKfYPeZbvBCObrFDXHyup05RtdTTWcgwXiuffYtEqzdtGv1yX7AruYE30SegATnGGsUBfQWRhd6UbDv1N8vm3i+H7DLUcDrshPlbXE3FWxx108qI7gqKktloceEbVMbJXiOE/yhRnpXrobjdA+556KA25FgmVMl5ECq571Rtq5gd0W2pDMNS/SyrTtaT9TsfNAxhXSmYQkK+GGy+8N/KNwrNMOeV275SrXPR4LLOMFrcgarmQxO3nWlPMD464kEK5FgbyiEAj5HgusnG8ZQecZtRhueasfSSAPkq+gHbN3mnatO4eRdk5gG1BrUq1ZyFQiXQnPqD9tC9xRsj2y4Z7D19FrgqqVwvKjjh2RQZGR5TmWhBwX8EzPCP6JwL6kFrlwSU1m4OYwECTp7BtecNeuOS6SycGUocpHYEXyCAvZpxoz5Qct5Tg1xjYITvKfE5PdUFlqi//sB4zIKVGV7aolrDJ3D7ScUZoFtjzHyGW1G1tYCN4llZkJFfX3F5XLHVdgTsK/7BpYvss01DiQYUzPxTmy5YFtKLTm2uEbBiW3XIqoNxeX9/e3HIsGomq0/9fDXFtco0rnQd3+045KRVlz4GidMtrjGgQS+9k5ui60j4Nm4uNwW1yj6+52jUcCHyhAZmKwsriMDDyT4TdXZFwmTLa5xoDz+Euywcrc34+pwgq1xwmSLaxycWLacMHGCz1Sd8VS28XzbXKNI1wXRqUiYSkVqtrhSFzixESQYlN4yKy/ol8JE8FEkTL0Zb0VxHXkAERep2eL6AWvVBqZhVgMg4Q8yyAsTwV6nikjNBjenEWyHDK7kQDomwOuC2FCPEFETJk7wcLlITR5y2OYaRTrjXRDF4pzgxXhD3K64ra0trlGgYK+qBo7oeYEIuSNq+F4Z+nPncONptrnG4AdsnTbCw3F1OMFjUR0/YLfY5hpD38DyRXKdVUvNwbjEQ8+gexES/KvW5A+i42lb3IrQPdS2mBP7ghP7qjjXpkPm2sq9XyjgbWXEYT9obrLNrQi9GW9FwXXiyXKjkb+MINinHbs7jplqhLuxYCh70ja3KqBwb/ADdmOpcpnwjAQolYVLqxEgW1xj8OvCxxae8FUKTuyhmQqQLa4xIMEydfQsDRmN21PrAsSJPWGbaxR8ngofJ6+ZE9wqr8vMuPMo3PXaYcLT1URetriFcvaTejW2zGIA2LtqFn6Ny7lPJ0C2uNoAjHBiBzh5bTPqfF94lpbL0qJgj8bV4QRvxQmQLa5RYJks7XSRly2ucaDK0qKA9/XzNHlPp1zkZYtrFFzL0srLi/JKHCfvJrlp0kSqs5a4xm+F80LWJe4a2kitcY2jb6DlVBQQTLokLWA/J7i73DHzXHKlGMq7RZzgb7kEcmKPdOxedbxjCt1DbYtlstIPmi9GguNqiZvKNjXKjk/xFgEvOXMFTt6G6bbSSSLaD6hByOTT6rlT4WuTN4DC+8OqwaZGZ46h3VoX+URuXi/g/sQN6M656SgK+DLxpSkG6oMJ6fIfhx9S6LECQdqZT0DhemEcIOCFyjnwQInV4oD8oMqZT+AEKeW6v1TKkeIYfaeg/cYSvUiZFMJTIII0EqyplsvJaw+/JBEM5auQjIV11FGHs0DwPxjwX3NERufNAAAAAElFTkSuQmCC"
                className="h-7 w-7"
              />
              <Link to={`/products/${nameOfTheSubCategory}`}>
                <h2 className="font-Manrope-ExtraLight text-[14px] py-1 border border-cp-green px-2 text-cp-white">
                  {nameOfTheSubCategory}
                </h2>
              </Link>

              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFiElEQVR4nO1ba2hcRRS+PuurYqU+kSJaaK2kyZ1zk8b4iIq29Z9YYv9UY5I7Z7PFSOsTnxGEUoUi0bI75yYSUxWx1DcIRcUHiP5Q1Aii9IfgE5uiVk19UBuZu3N3J5u72d1kbmYT9oP9kcx8d87MnPvNmTlzHaeOOuqoYwGgN7P6TCToRAH3oHC7Nu9sPjvRBpHgJCRgSLDUsQxO7E5O7BASTOR/gv3Fid3rTDhHGW8QhbuREzuYawiOcILHE2moElsI7pjU8eKfYPeZbvBCObrFDXHyup05RtdTTWcgwXiuffYtEqzdtGv1yX7AruYE30SegATnGGsUBfQWRhd6UbDv1N8vm3i+H7DLUcDrshPlbXE3FWxx108qI7gqKktloceEbVMbJXiOE/yhRnpXrobjdA+556KA25FgmVMl5ECq571Rtq5gd0W2pDMNS/SyrTtaT9TsfNAxhXSmYQkK+GGy+8N/KNwrNMOeV275SrXPR4LLOMFrcgarmQxO3nWlPMD464kEK5FgbyiEAj5HgusnG8ZQecZtRhueasfSSAPkq+gHbN3mnatO4eRdk5gG1BrUq1ZyFQiXQnPqD9tC9xRsj2y4Z7D19FrgqqVwvKjjh2RQZGR5TmWhBwX8EzPCP6JwL6kFrlwSU1m4OYwECTp7BtecNeuOS6SycGUocpHYEXyCAvZpxoz5Qct5Tg1xjYITvKfE5PdUFlqi//sB4zIKVGV7aolrDJ3D7ScUZoFtjzHyGW1G1tYCN4llZkJFfX3F5XLHVdgTsK/7BpYvss01DiQYUzPxTmy5YFtKLTm2uEbBiW3XIqoNxeX9/e3HIsGomq0/9fDXFtco0rnQd3+045KRVlz4GidMtrjGgQS+9k5ui60j4Nm4uNwW1yj6+52jUcCHyhAZmKwsriMDDyT4TdXZFwmTLa5xoDz+Euywcrc34+pwgq1xwmSLaxycWLacMHGCz1Sd8VS28XzbXKNI1wXRqUiYSkVqtrhSFzixESQYlN4yKy/ol8JE8FEkTL0Zb0VxHXkAERep2eL6AWvVBqZhVgMg4Q8yyAsTwV6nikjNBjenEWyHDK7kQDomwOuC2FCPEFETJk7wcLlITR5y2OYaRTrjXRDF4pzgxXhD3K64ra0trlGgYK+qBo7oeYEIuSNq+F4Z+nPncONptrnG4AdsnTbCw3F1OMFjUR0/YLfY5hpD38DyRXKdVUvNwbjEQ8+gexES/KvW5A+i42lb3IrQPdS2mBP7ghP7qjjXpkPm2sq9XyjgbWXEYT9obrLNrQi9GW9FwXXiyXKjkb+MINinHbs7jplqhLuxYCh70ja3KqBwb/ADdmOpcpnwjAQolYVLqxEgW1xj8OvCxxae8FUKTuyhmQqQLa4xIMEydfQsDRmN21PrAsSJPWGbaxR8ngofJ6+ZE9wqr8vMuPMo3PXaYcLT1URetriFcvaTejW2zGIA2LtqFn6Ny7lPJ0C2uNoAjHBiBzh5bTPqfF94lpbL0qJgj8bV4QRvxQmQLa5RYJks7XSRly2ucaDK0qKA9/XzNHlPp1zkZYtrFFzL0srLi/JKHCfvJrlp0kSqs5a4xm+F80LWJe4a2kitcY2jb6DlVBQQTLokLWA/J7i73DHzXHKlGMq7RZzgb7kEcmKPdOxedbxjCt1DbYtlstIPmi9GguNqiZvKNjXKjk/xFgEvOXMFTt6G6bbSSSLaD6hByOTT6rlT4WuTN4DC+8OqwaZGZ46h3VoX+URuXi/g/sQN6M656SgK+DLxpSkG6oMJ6fIfhx9S6LECQdqZT0DhemEcIOCFyjnwQInV4oD8oMqZT+AEKeW6v1TKkeIYfaeg/cYSvUiZFMJTIII0EqyplsvJaw+/JBEM5auQjIV11FGHs0DwPxjwX3NERufNAAAAAElFTkSuQmCC"
                className="h-7 w-7"
              />
            </div>

            <div className="flex flex-col justify-center items-center">
              <h2 className="font-Manrope-ExtraLight  text-cp-white text-3xl justify-center items-center pt-10 xs:hidden md:flex">
                <b>{productname.toUpperCase().replaceAll("-", " ")}</b>
              </h2>
              {currentLanguage === "de" ? (
                <p className="font-Manrope-ExtraLight   text-cp-white xs:w-[86%] md:w-[70%] xl:w-[50%]  xs:text-[12px] md:text-[15px] xs:mt-8 xl:text-[18px] xl:mt-16">
                  {germanDes}
                </p>
              ) : (
                <p className="font-Manrope-ExtraLight    text-cp-white xs:w-[86%] md:w-[70%] xl:w-[50%] xs:text-[12px] md:text-[15px] xs:mt-8 xl:text-[18px] xl:mt-16">
                  {EnglishDes}
                </p>
              )}
            </div>

            <div className="flex md:flex-row xs:flex-col justify-center items-center xs:gap-8 md:gap-10 ">
              <div className="xs:mt-10 md:mt-20">
                <div
                  className={`grid ${currentItems.length === 1 ? "xs:grid-cols-[175px] md:grid-cols-[256px] xs:gap-2 md:gap-[100px]" : currentItems.length === 2 ? "xs:grid-cols-[175px_175px] md:grid-cols-[256px_256px] xs:gap-2 md:gap-[100px]" : "xs:grid-cols-[175px_175px] md:grid-cols-[256px_256px]  lg:grid-cols-[256px_256px_256px] xs:gap-2 md:gap-[100px]"}  grid-row`}>
                  {currentItems.map((blockData, index) => (
                    <Card blockData={blockData} onCardClick={handleCardClick} />
                  ))}
                </div>
                <div
                  className={`xs:my-10 xl:my-16 ${articles.length < 6 ? "hidden" : "block"}`}>
                  <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={articles.length}
                    selectedPage={selectedPage}
                    currentPage={currentPage}
                  />
                </div>
              </div>
              {(selectedBlock || partid) && (
                <Dailog
                  selectedBlock={selectedBlock}
                  closeHandler={closeHandler}
                  articles={articles}
                />
              )}
            </div>
            <p className="text-cp-white flex justify-center font-Manrope-ExtraLight items-center xs:my-5 xl:my-10 xs:text-[12px]  xl:text-[15px] xs:mx-10 xl:mx-0">
              {t("textunderarticles")}
            </p>
          </div>
        </div>
      </div>
      <div className="xs:h-[5px] lg:h-[10px] bg-cp-white"></div>
    </div>
  );
};

export default Articles;
